import { createContext } from 'react';

export const HomeContext = createContext<HomeContextProps>({
    isAuthenticated: false,
    setAuthIsOpen: () => { },
    setShowInstallation: () => { },
    onClickLogOut: () => { },
    setShowLogout: () => { },
})

interface HomeContextProps {
    isAuthenticated: boolean;
    setAuthIsOpen: (isAuthOpen: boolean) => void;
    setShowInstallation: (value: boolean) => void;
    setShowLogout: (value: boolean) => void;
    onClickLogOut?: (url?: string) => void;
}